/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ActivityLogItemLinked,
  DeletePurchaseRequest,
  DownloadPurchaseRequestWithFilters,
  EditPurchaseRequestWithFilters,
  GetPurchaseRequestLinkedItemsRequest,
  GetPurchaseRequestLinkedToSpendParams,
  GetPurchaseRequestRequest,
  GetReferenceLinkedItemsPayload,
  GetSuggestionsByIdTextAndTypeParams,
  PagePurchaseRequestDto,
  PurchaseRequestActivityLogDto,
  PurchaseRequestDto,
  PurchaseRequestSummaryHeaderDto,
  SpendDtoObject,
  SuggestedInvoiceDto,
  UpdatePurchaseRequestsPayload,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiPurchaseRequestsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-purchase-requests-controller
   * @name UpdatePurchaseRequests
   * @request PUT:/api/v1/purchase-requests
   */
  updatePurchaseRequests = (data: UpdatePurchaseRequestsPayload, params: RequestParams = {}) =>
    this.http.request<PurchaseRequestDto[], any>({
      path: `/v1/purchase-requests`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updatePurchaseRequestsPath = '/v1/purchase-requests'
  static updatePurchaseRequestsMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-purchase-requests-controller
   * @name DeletePurchaseRequests
   * @request DELETE:/api/v1/purchase-requests
   */
  deletePurchaseRequests = (data: DeletePurchaseRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/purchase-requests`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static deletePurchaseRequestsPath = '/v1/purchase-requests'
  static deletePurchaseRequestsMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-purchase-requests-controller
   * @name UpdateAllPurchaseRequests
   * @request PUT:/api/v1/purchase-requests/all
   */
  updateAllPurchaseRequests = (data: EditPurchaseRequestWithFilters, params: RequestParams = {}) =>
    this.http.request<PurchaseRequestDto[], any>({
      path: `/v1/purchase-requests/all`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateAllPurchaseRequestsPath = '/v1/purchase-requests/all'
  static updateAllPurchaseRequestsMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-purchase-requests-controller
   * @name GetPurchaseRequestsSummary
   * @request POST:/api/v1/purchase-requests/summary
   */
  getPurchaseRequestsSummary = (data: GetPurchaseRequestRequest, params: RequestParams = {}) =>
    this.http.request<PurchaseRequestSummaryHeaderDto, any>({
      path: `/v1/purchase-requests/summary`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getPurchaseRequestsSummaryPath = '/v1/purchase-requests/summary'
  static getPurchaseRequestsSummaryMethod = 'POST'
  /**
   * No description
   *
   * @tags api-purchase-requests-controller
   * @name GetLinkedSpendsToPr
   * @request POST:/api/v1/purchase-requests/spendsLinked
   */
  getLinkedSpendsToPr = (data: GetPurchaseRequestLinkedItemsRequest, params: RequestParams = {}) =>
    this.http.request<SpendDtoObject[], any>({
      path: `/v1/purchase-requests/spendsLinked`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getLinkedSpendsToPrPath = '/v1/purchase-requests/spendsLinked'
  static getLinkedSpendsToPrMethod = 'POST'
  /**
   * No description
   *
   * @tags api-purchase-requests-controller
   * @name GetPagedPurchaseRequests
   * @request POST:/api/v1/purchase-requests/paged
   */
  getPagedPurchaseRequests = (data: GetPurchaseRequestRequest, params: RequestParams = {}) =>
    this.http.request<PagePurchaseRequestDto, any>({
      path: `/v1/purchase-requests/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getPagedPurchaseRequestsPath = '/v1/purchase-requests/paged'
  static getPagedPurchaseRequestsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-purchase-requests-controller
   * @name GetReferenceLinkedItems
   * @request POST:/api/v1/purchase-requests/linkedItems
   */
  getReferenceLinkedItems = (data: GetReferenceLinkedItemsPayload, params: RequestParams = {}) =>
    this.http.request<Record<string, ActivityLogItemLinked>, any>({
      path: `/v1/purchase-requests/linkedItems`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getReferenceLinkedItemsPath = '/v1/purchase-requests/linkedItems'
  static getReferenceLinkedItemsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-purchase-requests-controller
   * @name Download
   * @request POST:/api/v1/purchase-requests/download/{templateId}
   */
  download = (
    templateId: string,
    data: DownloadPurchaseRequestWithFilters,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/purchase-requests/download/${templateId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static downloadPath = '/v1/purchase-requests/download/${templateId}'
  static downloadMethod = 'POST'
  /**
   * No description
   *
   * @tags api-purchase-requests-controller
   * @name GetPurchaseRequestLinkedToSpend
   * @request GET:/api/v1/purchase-requests/{spendId}/purchaseRequestLinked
   */
  getPurchaseRequestLinkedToSpend = (
    { spendId, ...query }: GetPurchaseRequestLinkedToSpendParams,
    params: RequestParams = {},
  ) =>
    this.http.request<PurchaseRequestDto[], any>({
      path: `/v1/purchase-requests/${spendId}/purchaseRequestLinked`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getPurchaseRequestLinkedToSpendPath =
    '/v1/purchase-requests/${spendId}/purchaseRequestLinked'
  static getPurchaseRequestLinkedToSpendMethod = 'GET'
  /**
   * No description
   *
   * @tags api-purchase-requests-controller
   * @name GetPurchaseRequestDto
   * @request GET:/api/v1/purchase-requests/{purchaseRequestId}
   */
  getPurchaseRequestDto = (purchaseRequestId: string, params: RequestParams = {}) =>
    this.http.request<PurchaseRequestDto, any>({
      path: `/v1/purchase-requests/${purchaseRequestId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPurchaseRequestDtoPath = '/v1/purchase-requests/${purchaseRequestId}'
  static getPurchaseRequestDtoMethod = 'GET'
  /**
   * No description
   *
   * @tags api-purchase-requests-controller
   * @name GetSuggestionsByPrId
   * @request GET:/api/v1/purchase-requests/{purchaseRequestId}/suggestions
   */
  getSuggestionsByPrId = (purchaseRequestId: string, params: RequestParams = {}) =>
    this.http.request<SuggestedInvoiceDto[], any>({
      path: `/v1/purchase-requests/${purchaseRequestId}/suggestions`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSuggestionsByPrIdPath = '/v1/purchase-requests/${purchaseRequestId}/suggestions'
  static getSuggestionsByPrIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-purchase-requests-controller
   * @name GetSuggestionsByIdTextAndType
   * @request GET:/api/v1/purchase-requests/{purchaseRequestId}/suggestionsWithText
   */
  getSuggestionsByIdTextAndType = (
    { purchaseRequestId, ...query }: GetSuggestionsByIdTextAndTypeParams,
    params: RequestParams = {},
  ) =>
    this.http.request<SuggestedInvoiceDto[], any>({
      path: `/v1/purchase-requests/${purchaseRequestId}/suggestionsWithText`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getSuggestionsByIdTextAndTypePath =
    '/v1/purchase-requests/${purchaseRequestId}/suggestionsWithText'
  static getSuggestionsByIdTextAndTypeMethod = 'GET'
  /**
   * No description
   *
   * @tags api-purchase-requests-controller
   * @name GetActivityLogs
   * @request GET:/api/v1/purchase-requests/{purchaseRequestId}/activity
   */
  getActivityLogs = (purchaseRequestId: string, params: RequestParams = {}) =>
    this.http.request<PurchaseRequestActivityLogDto[], any>({
      path: `/v1/purchase-requests/${purchaseRequestId}/activity`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getActivityLogsPath = '/v1/purchase-requests/${purchaseRequestId}/activity'
  static getActivityLogsMethod = 'GET'
}
